import { resolvePath } from 'src/cdn';
import { isNil } from 'lodash';

export function mapNameToDefaultUri(name: string | undefined) {
  if (isNil(name)) {
    return undefined;
  }
  return resolvePath('maps/' + name + '.json');
}
